function t(o) {
  const r = [];
  let n;
  for (n in o)
    !o[n] || r.push(n);
  return r;
}
export {
  t as BooleanRecord2Array
};
//# sourceMappingURL=index2.js.map
